import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { queryKeys } from '../constants';

export function useGetCompanyConfigBookingDelay() {
  return useQuery<any>(
    [queryKeys.COMPANY_CONFIG_BOOKING_DELAY],
    async () => {
      const res = await $api.get(`/v1/company-config/booking-delay`);

      return res?.data?.data;
    },
    {
      refetchOnWindowFocus: false,
      onError: baseErrorHandler,
      retry: false
    }
  );
}
